import React from 'react';
import { formatFileSize, getEncryptedFilesLinks, shortenFileName } from 'utils';

const LinkedDocument: React.FC<{
  id: string;
  name?: string;
  description?: string;
  size?: number;
}> = ({ id, name = '', description = '', size }) => {
  const onClickViewFile = async () => {
    const { viewUrl } = await getEncryptedFilesLinks(id, name);
    window.open(viewUrl, '_blank');
  };
  const onClickDownloadFile = async () => {
    const { downloadUrl } = await getEncryptedFilesLinks(id, name);
    window.open(downloadUrl, '_blank');
  };

  return (
    <div>
      <span className='gx-link' onClick={onClickViewFile}>
        {shortenFileName(name)}
        {description ? `- ${description}` : ''}
      </span>
      {size && <span> {formatFileSize(size)}</span>}
      <span className='gx-link ml-2' onClick={onClickDownloadFile}>
        [Download]
      </span>
    </div>
  );
};

export default LinkedDocument;
